export class ResultadoOperacaoAditavel {
  idePac: number;
  podeAditar: boolean;
  operacaoN03: string;
}
